import axios from 'axios';

export const TEAM_PRODUCTS_UPDATED = 'TEAM_PRODUCTS_UPDATED';

const updateTeamProducts = (teamId, productIds, newProductName) => (
  dispatch => (
    axios.post(`/api/teams/${teamId}/products`, {
      product_ids: productIds,
      new_product_name: newProductName,
    }).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: TEAM_PRODUCTS_UPDATED,
          teamId,
          products: response.data.data,
        });
      }

      return response;
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location = '/login';
      }
    })
  )
);

export default updateTeamProducts;
